import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { guaranteeItems } from "../../data/content";
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-214" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-dashed border-gold/50 bg-cream px-5 py-10 text-center sm:px-10" data-id="element-215" data-mp="24l3tnaur47le">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-navy text-goldlight" data-id="element-216" data-mp="2ed9rh17opj8i">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-217" data-mp="2jb1m42zprjge" />
          <span className="mt-0.5 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-218" data-mp="2obgxwq4ckiw9">7 days</span>
        </div>
        <h2 className="text-balance mt-5 font-serif text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-219" data-mp="2sd2heubdzvff">
          Explore the Blueprint™ for 7 days, <em className="text-gold" data-id="element-220" data-mp="tyzjm81hkt3r">risk-free</em>
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-ink/75" data-id="element-221" data-mp="xzt40rfpzprw">
          I want you to be able to open the system and see whether it fits the way you learn. During your first 7
          days, you can:
        </p>

        <ul className="mx-auto mt-6 grid max-w-md gap-2.5 text-left sm:grid-cols-2" data-id="element-222" data-mp="3nt5bgijcdz8h">
          {guaranteeItems.map(g => <li key={g} className="flex items-start gap-2.5 text-[16px] font-medium text-ink" data-id="element-223" data-mp="3itajscrqt5md">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-224" data-mp="3duftkprg4es8" />
              {g}
            </li>)}
        </ul>

        <p className="mt-6 text-[16px] leading-relaxed text-ink/75" data-id="element-225" data-mp="ah4xz0elemlm">
          If you decide the system isn't useful for your professional education, contact us within the guarantee period
          according to the purchase terms. You can request a refund.
        </p>
        <p className="mt-3 font-serif text-xl font-bold italic text-navy" data-id="element-226" data-mp="2q7henwiz5ewf">Simple. No complicated process.</p>

        <div className="mt-8" data-id="element-227" data-mp="2l7liukkfktry">
          <CTAButton label="Try Mastopexy Blueprint™ risk-free for 7 days" data-id="element-228" data-mp="2l6blxypbdrmw" />
        </div>
      </div>
    </section>;
}